<template>
  <div style="background-color: white; min-height: 100vh">
    <v-app>
      <Header />
      <div class="page-wrap">
        <v-breadcrumbs
          divider="/"
          :items="breadcrumbs"
          class="breadcrumbs"
        ></v-breadcrumbs>
        <div style="padding: 0px 12px 12px 12px" class="width100">
          <div class="waiver-wrapper">
            <h1>Full Moon Paddle Tour Registration</h1>
            <div class="boxes">
              <!-- Participant Information -->
              <div v-for="n in count" :key="n" class="box">
                <p>Participant Information (required)</p>
                <div class="waiver-inputs">
                  <v-text-field
                    class="waiver-input"
                    type="text"
                    placeholder="First Name"
                    label="First Name"
                    v-model="participants[n - 1].firstname"
                    :rules="[(v) => !!v || 'First name is required']"
                  ></v-text-field>
                  <v-text-field
                    class="waiver-input"
                    type="text"
                    placeholder="Last Name"
                    label="Last Name"
                    v-model="participants[n - 1].lastname"
                    :rules="[(v) => !!v || 'Last name is required']"
                  ></v-text-field>
                  <v-select
                    v-model="participants[n - 1].type"
                    :items="['Adult (18+)', 'Minor (under 18)']"
                    label="Adult or Minor"
                    :rules="[(v) => !!v || '*']"
                  />
                  <v-select
                    v-model="participants[n - 1].skillLevel"
                    :items="[
                      'First-time Paddler',
                      'Beginner',
                      'Intermediate',
                      'Advanced',
                      'Expert',
                    ]"
                    label="Kayak Skill Level"
                    :rules="[(v) => !!v || '*']"
                  />
                </div>
              </div>

              <!-- Equipment Selection — Summer months (Jun-Sep): rental option -->
              <div v-if="rentalsAvailable" class="box">
                <p>Equipment Selection (required)</p>
                <div class="rental-notice">
                  <img
                    src="../../../assets/icons/error-24px.svg"
                    class="rental-notice-icon"
                    alt="notice icon"
                  />
                  <span>
                    <strong>Attention:</strong> Rentals will be available while
                    supplies last. Arrive <strong>45 minutes early</strong> to
                    rent and receive equipment.
                  </span>
                </div>
                <v-radio-group
                  v-model="equipmentChoice"
                  :rules="[(v) => !!v || 'You must select an option']"
                  class="equipment-radio-group"
                >
                  <v-radio
                    label="I will bring my own kayak or paddleboard."
                    value="own"
                    color="#96a145"
                  ></v-radio>
                  <v-radio
                    label="I plan to rent a kayak or paddleboard from Sand Hollow State Park."
                    value="rent"
                    color="#96a145"
                  ></v-radio>
                </v-radio-group>
              </div>

              <!-- Equipment Selection — Non-summer: must bring own -->
              <div v-else class="box">
                <p>Equipment Selection (required)</p>
                <v-checkbox
                  v-model="agreedToKayak"
                  :rules="[(v) => !!v || 'You must agree']"
                  class="greenLink"
                >
                  <template #label>
                    <span>
                      I understand that I have to bring
                      <span style="font-family: 'boldRoboto'"
                        >MY OWN KAYAK OR PADDLEBOARD</span
                      >
                      for this event.
                    </span>
                  </template>
                </v-checkbox>
              </div>

              <!-- Safety Requirements -->
              <div class="box">
                <p>Safety Requirements (required)</p>
                <v-checkbox
                  v-model="agreedToWhistle"
                  :rules="[(v) => !!v || 'You must agree']"
                  class="greenLink"
                >
                  <template #label>
                    <span>
                      I confirm that I will bring a
                      <span style="font-family: 'boldRoboto'">whistle</span>.
                    </span>
                  </template>
                </v-checkbox>
                <v-checkbox
                  v-model="agreedToLight"
                  :rules="[(v) => !!v || 'You must agree']"
                  class="greenLink"
                >
                  <template #label>
                    <span>
                      I confirm that I will bring a
                      <span style="font-family: 'boldRoboto'">LIGHT</span>
                      (headlamps work best).
                    </span>
                  </template>
                </v-checkbox>
                <v-checkbox
                  v-model="agreedToLifeJacket"
                  :rules="[(v) => !!v || 'You must agree']"
                  class="greenLink"
                >
                  <template #label>
                    <span>
                      I agree to bring my own
                      <span style="font-family: 'boldRoboto'">life jacket</span
                      >, unless renting a watercraft.
                    </span>
                  </template>
                </v-checkbox>
              </div>

              <!-- Disclaimer -->
              <div class="box">
                <p>Disclaimer</p>
                <v-checkbox
                  v-model="agreed"
                  :rules="[(v) => !!v || 'You must agree to the terms']"
                  class="greenLink"
                >
                  <template #label>
                    <span>
                      I agree to the following waiver and release:
                      <span
                        class="disclaimer-link"
                        @click.stop="showDisclaimer = true"
                      >
                        View Waiver and Release
                      </span>
                    </span>
                  </template>
                </v-checkbox>
              </div>
            </div>
            <v-dialog
              style="padding: 10px"
              v-model="showDisclaimer"
              max-width="600"
            >
              <v-card>
                <v-card-actions>
                  <v-spacer></v-spacer>
                  <v-btn text @click="showDisclaimer = false"> X </v-btn>
                </v-card-actions>
                <v-card-title class="headline">Waiver and Release</v-card-title>
                <v-card-text>
                  <p style="text-align: center">
                    This is a Waiver and Release for participation in a Utah
                    Division of State Parks and Recreation event or program or
                    independent program occurring in or about a Utah State Park.
                  </p>
                  <p>
                    Injury may result from your participation in this
                    outing/event/ program. Additionally, property damage or loss
                    may occur. You are expected to familiarize yourself with the
                    rules of conduct for the event/program as well as Utah
                    Division of State Parks and Recreation policies. You are
                    expected to follow proper operating procedures including
                    safety procedures, plus follow any directions given by an
                    authorized Utah State Parks employee or site steward.
                  </p>
                  <p>
                    The undersigned, being at least eighteen years of age, and
                    in consideration of participation in a State Parks
                    event/program or program or independent program occurring in
                    or about a Utah State Park (hereinafter "event/program"),
                    does hereby agree to this waiver and release.
                  </p>
                  <p>
                    I recognize that participation in the event/program may
                    involve moderate to strenuous physical activity and may
                    cause physical and or emotional distress to participants.
                    There may also be associated health risks. I state that I am
                    free from any known heart, respiratory or other health
                    problems that could prevent me from safely participating in
                    any of the activities.
                  </p>
                  <p>
                    I further agree to release the State of Utah, Utah Division
                    of State Parks and Recreation and its agencies, departments,
                    officers, employees, agents and all sponsors, officials and
                    staff or volunteers from any and all liability, claims,
                    demands, breach of warranty, negligence, actions, and causes
                    of actions whatsoever for any loss, claim, damage, injury,
                    illness, attorney's fees or harm of any kind or nature to me
                    arising out of my participation in the event/program. This
                    release extends to any claim made by my family, estate,
                    heirs, or assigns arising from or in any way connected with
                    the aforementioned activities.
                  </p>
                  <p style="text-align: center; font-size: 20px">Consent</p>
                  <p>
                    Consent is expressly given, in the event of injury, for any
                    emergency aid, anesthesia and / or operation, if in the
                    opinion of the attending physician, such treatment is
                    necessary.
                  </p>
                  <p>
                    I also consent to have any images taken of me participating
                    in this event used for the purposes of publicizing this
                    event and/or for the purposes of publicizing people's
                    general participation in parks events.
                  </p>
                  <p style="font-family: 'boldRoboto'">
                    I have carefully read and understand the contents of the
                    foregoing language and I specifically intend it to cover my
                    participation in the above stated event/program.
                  </p>
                </v-card-text>
              </v-card>
            </v-dialog>

            <div class="align-green-btn">
              <button
                class="green-btn"
                :disabled="!isFormValid()"
                :class="{ notValid: !isFormValid() }"
                @click="submitFrom()"
              >
                Checkout
              </button>
            </div>
          </div>
        </div>
        <div id="shopifyCollectionWrap" class="shopifyCollectionWrap">
          <div
            id="collection-component-1616176464282"
            class="collectionDiv"
          ></div>
        </div>
      </div>
    </v-app>
  </div>
</template>

<script src="https://evey-files.s3.amazonaws.com/js/evey_buy_button.js"></script>

<script>
import Header from "../../../components/Header.vue";
import $ from "jquery";
export default {
  name: "MoonlitWaiver",
  metaInfo: {
    title: "Moonlit Paddle Waiver",
    meta: [
      {
        name: "description",
        content:
          "Purchase your day-use pass for Sand Hollow Moonlit Paddle Event.",
      },
    ],
  },
  components: {
    Header,
  },
  data() {
    return {
      breadcrumbs: [],
      count: 0,
      participants: [],
      continueButton: false,
      varientId: this.$route.params.id,
      uuid: "",
      showDisclaimer: false,
      agreedToKayak: false,
      agreedToWhistle: false,
      agreedToLight: false,
      agreedToLifeJacket: false,
      agreed: false,
      date: "8/9",
      eventMonth: null,
      equipmentChoice: null,
    };
  },
  computed: {
    // Rentals available June (5), July (6), August (7), September (8)
    rentalsAvailable() {
      return [5, 6, 7, 8].includes(this.eventMonth);
    },
  },
  created() {
    this.uuid = this.generateUUID();
    this.eventMonth = Number(localStorage.getItem("eventMonth"));
    console.log("participant: ", this.participant);
    console.log("varientId: " + this.varientId);
    this.count = Number(localStorage.getItem("numberOfParticipants") || 0);
    for (let i = 0; i < this.count; i++) {
      this.participants.push({
        agreedToKayak: false,
        agreedToWhistle: false,
        agreedToLight: false,
        agreedToLifeJacket: false,
        agreed: false,
        event: "45497776996505",
        passId: "",
        firstname: "",
        lastname: "",
        email: "",
        skillLevel: "",
        minor: "0",
        type: "",
        guardianFirstName: "",
        guardianLastName: "",
      });
    }
    this.breadcrumbs = [
      { text: "Home", disabled: false, href: "/" },
      {
        text: "Sand Hollow State Park",
        disabled: false,
        href: "/parks/" + this.$route.params.name + "/dayuse",
      },
      {
        text: "Moonlit Paddle",
        disabled: false,
        href: "/parks/UTSAND/moonlit",
      },
      { text: "Waiver", disabled: true },
    ];
  },
  methods: {
    isFormValid() {
      for (let i = 0; i < this.participants.length; i++) {
        this.participants[i].agreed =
          this.agreed &&
          this.agreedToWhistle &&
          this.agreedToLight &&
          this.agreedToLifeJacket &&
          this.isEquipmentValid();
      }
      const p = this.participants;
      for (let i = 0; i < p.length; i++) {
        if (!this.isParticipantValid(p[i])) {
          return false;
        }
      }
      return true;
    },
    isEquipmentValid() {
      if (this.rentalsAvailable) {
        return !!this.equipmentChoice;
      } else {
        return this.agreedToKayak;
      }
    },
    isParticipantValid(participant) {
      const p = participant;
      if (!p) return false;
      return p.firstname && p.lastname && p.type && p.skillLevel && p.agreed;
    },
    submitFrom() {
      console.log("you can move onto the next page from adult");
      var _this = this;
      this.participants.forEach((participant) => {
        participant.minor = participant.type === "Minor (under 18)" ? "1" : "0";
        participant.agreedToKayak = _this.rentalsAvailable
          ? _this.equipmentChoice === "own"
          : _this.agreedToKayak;
        participant.agreedToWhistle = _this.agreedToWhistle;
        participant.agreedToLight = _this.agreedToLight;
        participant.agreedToLifeJacket = _this.agreedToLifeJacket;
        participant.agreed = _this.agreed;
        participant.passId = _this.uuid;
        participant.guardianFirstName = participant.skillLevel;
        if (_this.rentalsAvailable) {
          participant.equipmentChoice = _this.equipmentChoice;
        }
      });
      for (let f in this.participants) {
        var data = this.participants[f];
        console.log("data: ", data);
        data = JSON.stringify(data);
        console.log("data: ", data);
        $.ajax({
          url: "https://trailwaze.info/waivers/addWaiver.php",
          type: "POST",
          dataType: "json",
          data: data,
          success: function (json) {
            _this.json = json;
            console.log("new json: ", _this.json);
          },
          error: function (xhr, status, error) {
            console.log("Error: " + error);
          },
        });
      }
      this.MakeShiftShopify();
    },
    generateUUID() {
      let d = new Date().getTime();
      let d2 =
        (performance && performance.now && performance.now() * 1000) || 0;
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
        /[xy]/g,
        function (c) {
          let r = Math.random() * 16;
          if (d > 0) {
            r = (d + r) % 16 | 0;
            d = Math.floor(d / 16);
          } else {
            r = (d2 + r) % 16 | 0;
            d2 = Math.floor(d2 / 16);
          }
          return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
        }
      );
    },
    MakeShiftShopify() {
      console.log("make shift shopify");
      var client = ShopifyBuy.buildClient({
        domain: "parkspassutah.myshopify.com",
        storefrontAccessToken: "a245460c3b59913598a8b8b1f049af40",
      });

      var variantId = "45497776996505";
      var quantity1 = this.participants.length;
      console.log("quantity: ", quantity1);
      variantId = window.btoa(`gid://shopify/ProductVariant/${variantId}`);

      const uuid = this.uuid;

      let customAttributes = [
        { key: "UUID", value: uuid },
        { key: "event_date", value: this.date },
      ];

      if (this.rentalsAvailable) {
        customAttributes.push({
          key: "equipment",
          value: this.equipmentChoice === "rent" ? "Rental" : "Bringing Own",
        });
      }

      for (let i = 0; i < this.participants.length; i++) {
        console.log("Participant: ", this.participants[i]);
        const fullName = `${this.participants[i].firstname} ${this.participants[i].lastname}`;
        customAttributes.push({
          key: `participant${i + 1}`,
          value: fullName,
          key: `Skill level`,
          value: this.participants[i].skillLevel,
        });
      }

      client.checkout
        .create({
          customAttributes: customAttributes,
        })
        .then((checkout) => {
          var lineItemsToAdd = [
            {
              variantId: variantId,
              quantity: quantity1,
            },
          ];
          return client.checkout.addLineItems(checkout.id, lineItemsToAdd);
        })
        .then((checkout) => {
          window.location.href = checkout.webUrl;
        })
        .catch((error) => {
          console.error("Error:", error);
        });
    },
  },
};
</script>

<style scoped>
p {
  line-height: 22px;
}
.v-card-text {
  max-height: 60vh;
  overflow-y: auto;
}
.greenLink {
  color: #96a145;
  font-size: 16px;
  font-family: "boldRoboto";
  margin: 4px 0px;
  display: block;
  cursor: pointer;
}
.green-btn {
  height: 42px;
  line-height: 42px;
  border-radius: 32px;
  background-color: #96a145;
  color: white;
  width: 140px;
  padding: 0px 16px;
  text-align: center;
  font-size: 16px;
  font-family: "regularRoboto";
  margin-top: 8px;
  cursor: pointer;
}
.green-btn:hover {
  background-color: #818a3c;
}
.align-green-btn {
  display: flex;
  width: 100%;
  flex-direction: column;
  align-items: flex-end;
  margin-top: 20px;
}
.v-breadcrumbs ::v-deep(a) {
  color: #96a145 !important;
}
v-btn {
  background-color: none !important;
  color: rgb(53, 53, 53) 5 !important;
}
.waiver-wrapper {
  width: 70%;
  margin: 30px;
  display: flex;
  flex-direction: column;
}
.waiver-wrapper h1 {
  font-size: 40px;
  font-family: "boldRoboto";
  margin-bottom: 40px;
  line-height: 1.3;
}
.width100 {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.boxes {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
.box {
  width: 100%;
  border-radius: 8px;
  padding: 30px;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
  background-color: #f1f1e7;
}
.box p {
  font-size: 20px;
  font-family: "boldRoboto";
  margin-bottom: 16px;
}
.waiver-inputs {
  display: flex;
  justify-content: space-between;
  margin-top: 16px;
  gap: 16px;
  align-items: flex-end;
}
.waiver-input {
  width: 100%;
  border-radius: 8px;
  outline-color: #818a3c;
}
.notValid {
  background-color: #d9d9d9 !important;
  cursor: not-allowed;
}
.page-wrap {
  padding: 16px;
}
.rental-notice {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  border-radius: 4px;
  border: 2px solid #3b95a3;
  background: #f1f8f9;
  padding: 14px 18px;
  margin-bottom: 20px;
  font-family: "Roboto";
  font-size: 16px;
  line-height: 1.5;
  color: #5a4e00;
}
.rental-notice-icon {
  margin-top: 2px;
  flex-shrink: 0;
}
.equipment-radio-group {
  margin-top: 8px;
}
.equipment-radio-group .v-radio {
  margin-bottom: 8px;
}
@media only screen and (max-width: 850px) {
  .page-wrap {
    padding: 16px;
  }
  .waiver-inputs {
    flex-direction: column;
    align-items: flex-start;
  }
  .waiver-wrapper {
    margin: 0px;
    width: 100%;
  }
}
.disclaimer-link {
  display: inline;
  color: #96a145;
  text-decoration: underline;
  cursor: pointer;
  font-weight: bold;
  margin-left: 5px;
}
.v-input--is-label-active .v-label {
  background-color: white;
  padding: 0 4px;
}
</style>
